import { render, staticRenderFns } from "./LampiranManager.vue?vue&type=template&id=530a3f11&scoped=true"
import script from "./LampiranManager.vue?vue&type=script&lang=js"
export * from "./LampiranManager.vue?vue&type=script&lang=js"
import style0 from "./LampiranManager.vue?vue&type=style&index=0&id=530a3f11&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "530a3f11",
  null
  
)

export default component.exports